import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  description: {
    color: theme.palette.labraText.description,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    fontFamily: theme.typography.fontFamily,
    letterSpacing: '0.25px',
  },
  externalLinkIcon: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    color: theme.palette.select.light,
    textDecoration: 'none',
    width: 'fit-content',
    alignItems: 'center',
    flexDirection: 'row',
    letterSpacing: '0.1px',
    marginRight: theme.spacing(1.5),
  },
  selectTemplateContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  exampleText: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    letterSpacing: '0px',
  },
}))
